export default {
  authNotice: {
    summary: 'Info',
    content: 'Please login first!',
  },
};
